import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #ffffff;
  margin-bottom: 2rem;
  text-align: center;
`;

const Content = styled.div`
  color: #cccccc;
  line-height: 1.6;
  font-size: 1rem;
`;

const Question = styled.h2`
  font-size: 1.125rem;
  color: #ffffff;
  margin: 1.5rem 0 0.5rem 0;
`;

const Answer = styled.div`
  margin-bottom: 1.25rem;
`;

const TOS: React.FC = () => {
  return (
    <Container>
      <Title>Frequently Asked Questions</Title>
      <Content>
        <Question>How do I cancel or change my subscription?</Question>
        <Answer>
          <p>
            Cancelations and changes can be made on the <Link to="/subscription">subscription page</Link>. You can upgrade, downgrade or cancel at any time. Upgrades/downgrades will be pro-rated (you get a discount or credit for the unused portion of your current subscription). Cancelations will be applied at the end of your current billing cycle or trial period, so you can continue using the service until the end of the billing cycle or trial period.
          </p>
        </Answer>

        <Question>I have a question, comment or support issue. How do I contact you?</Question>
        <Answer>
          <p>
            Click on your profile icon on the top right of the screen, and select "Send Feedback".
          </p>
        </Answer>

        <Question>Why do so many meditations have annoying background sounds?</Question>
        <Answer>
          <p>
            The background sounds in some meditations are an intentional part of a process called brainwave entrainment, and it's completely normal for them to sound unusual or "annoying" at first. Unlike a musical soundtrack, the goal isn't to create a relaxing melody but to use specific frequencies to influence your brain.
          </p>
          <p>
            <strong>How it works:</strong> When you listen with headphones, each ear hears a slightly different frequency—for example, 200 Hz in the left ear and 205 Hz in the right.
          </p>
          <p>
            <strong>The "magic" in your brain:</strong> Your brain then perceives a third, phantom beat based on the difference between the two frequencies (in this case, 5 Hz).
          </p>
          <p>
            <strong>Encouraging a new state:</strong> This new, low-frequency "beat" can encourage your brainwaves to match, or "entrain," to that new frequency. This can help guide your mind toward a specific mental state, like deep relaxation (Theta waves), or enhanced focus (Beta waves).
          </p>
          <p>
            The sound is a tool, and its effectiveness relies on this specific auditory illusion. With repeated exposure, you may find the sound becomes less distracting as your brain adjusts to the therapeutic effect.
          </p>
        </Answer>
      </Content>
    </Container>
  );
};

export default TOS;